/*
 * @Description: 资源压缩
 */

import { translate } from './i18n/index.js';

// ---------------------------------------------------------------------------

/**
 * 图片压缩质量
 */
const img_quality = 50;

/**
 * 图片压缩
 * @param {*} url 图片路径
 * @param {*} quality 图片压缩质量
 * @param {*} i 该视频是第几个资源
 */
function imageCompress(url, quality = img_quality, i) {
	return new Promise((resolve, reject) => {
		uni.compressImage({
			src: url,
			quality,
			success: resolve,
			fail: reject,
			/* complete: (e) => {
				console.log(getApp().translate('IMAGE_COMPRESSION_COMPLETE'), e, i)
			} */
		})
	})
}

// ---------------------------------------------------------------------------

/**
 * 视频压缩质量
 */
let video_quality = 'low'; // low、medium、high

/**
 * 视频压缩
 * @param {*} url 视频路径
 * @param {*} quality 视频压缩质量
 * @param {*} i 该视频是第几个资源
 */
function videoCompress(url, quality = video_quality, i) {
	return new Promise((resolve, reject) => {
		uni.compressVideo({
			src: url,
			quality,
			success: resolve,
			fail: reject,
			/* complete: (e) => {
				console.log(getApp().translate('VIDEO_COMPRESSION_COMPLETE'), e, i)
			} */
		})
	})
}

// ---------------------------------------------------------------------------

export default {
	value: {},
	method: {
		imageCompress,
		videoCompress,
	}
};